// extracted by mini-css-extract-plugin
export default {"foundation":"ExploreOtherRoles_foundation__nuFha","container":"ExploreOtherRoles_container__Wt8vo"};